import { Select } from "antd";
import { RESUME_SECTION_TYPES } from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";

export default function Interests({
  id,
  data,
  onChange,
  onDelete,
  allCollapsed,
}) {
  const items = data ?? [];
  return (
    <SectionCardShell
      id={id}
      type={RESUME_SECTION_TYPES.INTERESTS}
      data={data}
      onChange={onChange}
      onDelete={onDelete}
      allCollapsed={allCollapsed}
    >
      <label className="flex flex-col gap-1 text-sm text-[#475467]">
        <span>Hobbies &amp; interests</span>
        <Select
          mode="tags"
          value={items}
          onChange={(vals) => onChange(vals)}
          placeholder="e.g. Long-distance running, Chess, Mechanical keyboards"
          tokenSeparators={[","]}
          style={{ width: "100%" }}
        />
      </label>
    </SectionCardShell>
  );
}
